import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import Modal from '../../../ui/Modal';

const blockEl = 'invoices__charge-card-modal';

const ChargeCardModal = ({
  isOpen,
  onClose,
  invoiceIdArray,
  chargeableInvoiceData,
  onSave,
}) => {
  const handleOnSubmit = (e) => {
    e.preventDefault();
    onSave();
  };

  return (
    <Modal isOpen={isOpen} className={blockEl} toggle={onClose} style={{ maxWidth: '550px' }}>
      <Modal.Header toggle={onClose}>
        Charge {invoiceIdArray.length === 0 && 'All'} Cards
      </Modal.Header>
      <form onSubmit={handleOnSubmit} noValidate>
        <Modal.Body>
          <div className="mb-4">
            All invoices that have eligible cards will be charged.
            If the user does not have a valid card on file,
            they will not be charged, and you will need to contact the bidder to arrange payment.
          </div>
          <div className="float-left">
            <div className="font-weight-bold">
              Total Invoices
            </div>
            <div>
              {chargeableInvoiceData.invoiceCount}
            </div>
          </div>
          <div className="float-left ml-4 pl-2">
            <div className="font-weight-bold">
              Total Eligible Invoices
            </div>
            <div>
              {chargeableInvoiceData.eligibleCount}
            </div>
          </div>
          <div className="float-right">
            <div className="font-weight-bold">
              Total Pending Charges
            </div>
            <div>
              {chargeableInvoiceData.totalCharges}
            </div>
          </div>
          <div className="clearfix mb-4" />
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" color="link" onClick={onClose}>Cancel</Button>
          <Button type="submit" color="primary">Process Payments</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

ChargeCardModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};

ChargeCardModal.defaultProps = {
  isOpen: false,
  onClose: Function.prototype,
  onSave: Function.prototype,

};

export default ChargeCardModal;
